define('views/modules/member/supervisors/supervisors',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils', 'moment',
    // views
    'views/parts/form/button',
    'views/modules/supervisor/supervisor-list',
    // models & collections
    'collections/member/supervisors',
    // templates
    'text!templates/modules/member/supervisors/supervisors.html',
], function(
    // Libs
    _, Backbone, Mustache, U, moment,
    // views
    VButton,
    VSupervisorList,
    // models & collections
    Supervisors,
    // templates
    TMemberSupervisors
) {

    var VMemberSupervisors = Backbone.View.extend({
        template: TMemberSupervisors,

        events: {
            "click .next-coach": "onNextCoachClick"
        },

        regions: {
            list: ".coachs",
            next: ".next-coach"
        },

        initialize: function(opt) {
            opt = opt || {};

            var view = this.view = {
                list: new VSupervisorList({
                    collection: Supervisors,
                    url: opt.url,
                    group: opt.group,
                    profile: this.model
                }),
            };

            this.listenTo(Supervisors, { 'sync': this.onSupervisorsSync });
        },

        render: function() {

            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext()));

            this.generateZones();
            var view = this.view,
                zone = this.zone;

            this.assign(view.list, zone.$list);

            this.toggleNextCoachButton();

            return this;
        },

        toggle: function(val) {
            if (!_.isUndefined(val)) val = !val;
            this.$el.toggleClass('hidden', val);
        },

        toggleNextCoachButton: function() {
            if (this.zone) {
                this.zone.$next.toggle(Supervisors.length > 1);
            }
        },

        //////////////
        // events //
        ////////////

        onNextCoachClick: function() {
            var zone = this.zone.$list,
                first = zone.find('.coach:first-child');

            first.addClass('move');

            first[0].addEventListener("transitionend", function moveCoach() {
                first.remove().removeClass('move');
                zone.find('.coach:last').after(first);
                first[0].removeEventListener("transitionend", moveCoach);
            });
        },

        onSupervisorsSync: function(collection) {
            this.toggleNextCoachButton();
        },

    });

    return VMemberSupervisors;

});

